var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',{staticClass:"badge badge-soft-secondary mt-n1 ml-1",class:{'badge-soft-success':_vm.value>0,'badge-soft-danger':_vm.value<0}},[_vm._v(_vm._s(_vm.value)+"%")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }